module.exports = __webpack_public_path__ + "img/Aparat.18f5c736.png";